<div class="login">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="login__table">
          <div class="login__tr">
            <div class="login__td">
              <h2>
                Bienvenido al
              </h2>
              <h1>
                Portal para <br> licencias de conducir
              </h1>
            </div>
            <div class="login__td">
              <h3>
                Bienvenido
              </h3>
              <h4 class="u-mb30">
                Ingresa con tu cuenta para consultar, solicitar o Aprobar solicitudes.
              </h4>
              <div class="form u-mb30">
                <label for="" class="label">
                  Usuario <span class="bhptooltip" data-text="Ejemplo de prueba">
                  </span>
                </label>
                <input type="text" placeholder="Ingresar correo" (keyup)="onKeyUpEmail($event)">
              </div>

              <div class="form u-mb20">
                <label for="" class="label">
                  Contraseña <span class="bhptooltip" data-text="Ejemplo de prueba">
                  </span>
                </label>
                <input type="password" (keyup)="onKeyUpPassword($event)" placeholder="Ingresar contraseña">
              </div>
              <div class="u-right">
                <button type="button" class="btn btn--primary btn--round" (click)="onLogin()">Ingresar</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
